import React from "react";
import Modal from "react-modal";

const ImageModal = ({ images, title, closeModal }) => {
  console.log("Images:",images)
  const hasImages = (images && images.length > 0 && !(Array.isArray(images) && images.length === 1 && images[0] === ''));

  return (
    <Modal
      isOpen={Boolean(images.length)}
      onRequestClose={closeModal}
      className="restaurant-image-modal"
      overlayClassName="image-overlay"
    >
      <div className="image-modal-header">
        <h2>{title}</h2>
      </div>

      <div className="image-gallery">
        {hasImages ? (
          images.map((img, index) => (
            <img key={index} src={`https://restaurantapi.nextdaysoft.com${img}`} alt="Restaurant" />
          ))
        ) : (
          <p className="no-image-text">No Images Found</p>
        )}
      </div>

      <div className="modal-footer">
        <button className="close-modal-btn" onClick={closeModal}>Close</button>
      </div>
    </Modal>
  );
};

export default ImageModal;
